<template>
  <div class="record-wrap">
    <van-list class="refreshWrap" v-model="isRefresh" @load="onLoad" finished-text="没有更多了" :finished="finished">
      <ul class="appoint-list">
        <li class="appoint" v-for="item in appointList" :key="item.ReservationID">
          <h3 class="fileName">{{item.FileNameUpload + item.FileExtension}}</h3>
          <div class="between-info">
            <span>{{item.FullName}}</span>
            <p class="right-info"><span>{{item.FileContentLengthName}}</span><span>{{item.CreateByDate}}</span></p>
          </div>
          <van-divider></van-divider>
          <p class="see-btn">
            <span @click="downLoadFile(item.FileID)">
              <van-icon name="edit"></van-icon>
              <a href="javascript:;">下载</a>
            </span>
            <span style="margin-left: 20px;" @click="deleteFile(item.FileID)">
              <van-icon name="edit"></van-icon>
              <a href="javascript:;">删除</a>
            </span>
          </p>
        </li>
      </ul>
    </van-list>
  </div>
</template>
<script>

  export default {
    name: 'FileList',
    data() {
      return {
        isRefresh: false,
        finished: false,
        appointList: [],
        totalItems: 0,
        pageIndex: 0,
        pageSize: 15,
        searchType: 1,
      }
    },
    created() {
    },
    methods: {

      downLoadFile(id) {
        this.xy.downFile(this.$store.state.apiPath + '/api/FileManage/DownloadById?id='+id)
      },
      deleteFile(id) {
        this.xy.confirm('删除提示', '你确定要删除吗？', this.deletePost.bind(this, id))
      },
      async deletePost(id) {
        let res = await this.xyapi.post(this.$store.state.apiPath + '/api/FileManage/Delete?id=' + id);
        if(res.success) {
          this.appointList = []
          this.getList()
          this.xy.msgSuc('删除成功')
        }
      },

      async getList() {
        var params = {
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          state: 0
        }
        let res = await this.xyapi.get(this.$store.state.apiPath + '/api/FileManage/GetPage', params);
        if (res.success) {
          // 加载状态结束
          this.isRefresh = false;

          if (res.data.data) {
            this.totalItems = res.data.totalRecords
            this.appointList = this.appointList.concat(res.data.data)
          } else {
            this.finished = true;
          }
          if (this.appointList.length >= this.totalItems) {
            this.finished = true;
          }
        }

      },
      onLoad() {
        this.pageIndex++
        this.getList()
      }
    }
  }
</script>
<style lang="less" scoped>
  .record-wrap {
    .appoint-list {
      font-size: 28px;

      .appoint {
        height: 248px;
        width: 100%;
        padding: 30px 20px;
        background: #fff;
        box-sizing: border-box;
        margin-top: 16px;

        h3 {
          font-size: 28px;
          margin-bottom: 10px;
        }

        .between-info {
          display: flex;
          justify-content: space-between;
          align-items: flex-end;

          .right-info {
            display: flex;
            flex-direction: column;
            text-align: right;
          }
        }


        .see-btn {
          color: #f90;
          display: flex;
          justify-content: flex-end;

          a {
            color: #f90;
            margin-left: 10px;
          }
        }

      }
    }
  }
</style>
